(($) => {
    let $body;
    let $forms;

    $(document).on('ready', init);
    
    function init() {
        $body = $('body');
        $forms = $('form.zc2market-router-form');

        if ($forms.length == 0) {
            return false;
        }

        $forms.each(initForm);
    }

    function initForm(formIndex, formElement) {
        if (!formElement) {
            return false;
        }

        let $form = $(formElement);
        let $zipCodeInput = $form.find('input.zip-code');
        let $submitButton = $form.find('button[type="submit"]').attr('type', 'button');

        let $countySelectModal;
        let $countySelectModalContentContainer;
        let $countySelectModalForm;
        let $countySelectModalSelect;
        let $countySelectModalCounty;

        let $errorModal;

        bind();

        $form.addClass('initialized');

        function bind() {
            $zipCodeInput.on('keyup', onKeyUp);
            $zipCodeInput.on('focus', onFocus);
            $form.on('submit', onFormSubmit);
            $submitButton.on('click', onSubmitButtonClick);
            $(window).on('beforeunload', onWindowBeforeUnload);
        }

        function initCountySelectModal(selectOptions) {
            if (!selectOptions) {
                return false;
            }

            createCountySelectModal(selectOptions);

            $countySelectModalSelect.on('change', onCountyModalSelectChange);
        }

        function initErrorModal(errorMessage) {
            if (!errorMessage) {
                return false;
            }

            createErrorModal(errorMessage);  
        }

        function getRoute(options) {
            return fetch('/wp-json/lumeris/v1/get-market-route/?' + generateQueryString(options), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cache: 'no-cache'
            }).then((response) => {
                return response.json();
            }).catch((error) => {
                console.error(error);
                return [];
            });
        }

        function createCountySelectModal(selectOptions) {
            if (!selectOptions) {
                return false;
            }

            $countySelectModal = $(
                `<div id="zc2market-router-county-modal" class="zc2market-router-county-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body"></div>
                            <div class="modal-footer text-center">
                                <button type="button" class="btn btn-no-style" data-bs-dismiss="modal" data-bs-target="#zc2market-router-county-modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>`);
            
            $countySelectModal.modal();
            
            $countySelectModalSelect = $('<select class="form__select w-100 w-sm-auto mb-1 mb-sm-0" name="market"><option selected disabled hidden>Select your county</option></select>');
            for (let county in selectOptions) {
                $countySelectModalSelect.append($('<option value="' + selectOptions[county] + '">' + county + '</option>'));
            }

            $countySelectModalCounty = $('<input type="hidden" name="county" value="">');

            $countySelectModalForm = $form.clone();
            $countySelectModalForm.find('input').attr('type', 'hidden');
            $countySelectModalForm.find('button').remove();
            $countySelectModalForm.append($countySelectModalSelect);
            $countySelectModalForm.append($countySelectModalCounty);

            $countySelectModalContentContainer = $countySelectModal.find('.modal-body');
            $countySelectModalContentContainer.append($countySelectModalForm);

            $countySelectModal.on('hidden.bs.modal', function(event) {
                removeCountySelectModal();
            });
        }

        function createErrorModal(errorMessage) {
            if (!errorMessage) {
                return false;
            }

            $errorModal = $(
                `<div id="zc2market-router-error-modal" class="zc2market-router-error-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body">${errorMessage}</div>
                            <div class="modal-footer text-center">
                                <button type="button" class="btn btn-no-style" data-bs-dismiss="modal" data-bs-target="#zc2market-router-error-modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>`);
            
            $errorModal.modal();

            $errorModal.on('hidden.bs.modal', function(event) {
                removeErrorModal();
            });
        }

        function showCountySelectModal() {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'show_modal' }}));
            $countySelectModal.modal('show');
        }

        function showErrorModal() {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'show_modal' }}));
            $errorModal.modal('show');
        }

        function removeCountySelectModal() {
            if (!$countySelectModal || $countySelectModal.length == 0 || typeof $countySelectModal.modal == 'undefined') {
                return null;
            }
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'close_modal' }}));
            $countySelectModal.modal('hide');
            $countySelectModal.modal('dispose');
            $countySelectModal.remove(); 
        }

        function removeErrorModal() {
            if (!$errorModal || $errorModal.length == 0 || typeof $errorModal.modal == 'undefined') {
                return null;
            }

            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'close_modal' }}));
            $errorModal.modal('hide');
            $errorModal.modal('dispose');
            $errorModal.remove(); 
        }

        function validateZipCode() {
            let filteredVal = $zipCodeInput.val().replace(/\D/g, '').slice(0, 5);
            $zipCodeInput.val(filteredVal);
        }

        function onWindowBeforeUnload(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }

            $form.attr('action', '');
            removeCountySelectModal();
            removeErrorModal();
        }

        function onKeyUp(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }
            validateZipCode();
        }

        function onFocus(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'focus' }}));
        }

        function onFormSubmit(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }

            if ($form.attr('action') == '') {
                event.preventDefault();
                return onSubmitButtonClick(event);
            }

            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'submit' }}));
        }

        async function onSubmitButtonClick(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }

            event.preventDefault();

            let formData = new FormData($form.get(0));

            let route = await getRoute({
                zipCode: formData.get('zipCode'),
                planYear: formData.get('planYear'),
                _wpnonce: formData.get('_wpnonce'),
                _wp_http_referer: formData.get('_wp_http_referer')
            });

            if (typeof route.error_message !== 'undefined') {
                if (typeof route.permalink !== 'undefined') {
                    $form.append($('<input type="hidden" name="error_message" value="' + encodeURIComponent(route.error_message) + '">'));
                    $form.attr('action', route.permalink);
                    $form.get(0).submit();
                    return false;
                }
                
                removeCountySelectModal();
                initErrorModal(route.error_message);
                showErrorModal();

                return false;
            }

            if (typeof route.permalink !== 'undefined') {
                $form.attr('action', route.permalink);
                $form.get(0).submit();
                $form.attr('action', '');
                return true;
            }

            if (typeof route.counties !== 'undefined') {
                removeErrorModal();
                initCountySelectModal(route.counties);
                showCountySelectModal();
                return false;
            }

            return false;
        }

        async function onCountyModalSelectChange(event) {
            if (event.originalEvent instanceof Event === false) {
                return null;
            }
            event.preventDefault();

            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'select' }}));

            $countySelectModalCounty.val($countySelectModalSelect.children('option:selected').text());
            
            let formData = new FormData($countySelectModalForm.get(0));

            let route = await getRoute({
                zipCode: formData.get('zipCode'),
                market: formData.get('market'),
                county: formData.get('county'),
                planYear: formData.get('planYear'),
                _wpnonce: formData.get('_wpnonce'),
                _wp_http_referer: formData.get('_wp_http_referer')
            });

            if (typeof route.error_message !== 'undefined') {
                if (typeof route.permalink !== 'undefined') {
                    $countySelectModalForm.append($('<input type="hidden" name="error_message" value="' + encodeURIComponent(route.error_message) + '">'));
                    $countySelectModalForm.attr('action', route.permalink);
                    $countySelectModalForm.get(0).submit();
                    return null;
                }

                removeCountySelectModal();
                initErrorModal(route.error_message);
                showErrorModal();
                return null;
            }

            if (typeof route.permalink !== 'undefined') {
                $countySelectModalForm.attr('action', route.permalink);
                $countySelectModalForm.get(0).submit();
                return true;
            }
            

            return null;
        }
    }

    function generateQueryString(params={}) {
        return Object.keys(params).map((key) => {
            return (typeof params[key] == 'string' || typeof params[key] == 'boolean') ? key + '=' + encodeURIComponent(params[key]) : key + '=' + encodeURIComponent(params[key].join(','));
        }).join('&');
    }

})(jQuery);